import { render, staticRenderFns } from "./Create-Purchase-Order.vue?vue&type=template&id=40a7fc52&scoped=true"
import script from "./Create-Purchase-Order.vue?vue&type=script&lang=js"
export * from "./Create-Purchase-Order.vue?vue&type=script&lang=js"
import style0 from "./Create-Purchase-Order.vue?vue&type=style&index=0&id=40a7fc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7fc52",
  null
  
)

export default component.exports